import * as R from 'ramda';

export const getFirstName = (name: string) => R.head(name.split(' ') ?? []);
